/**
 * DramaBadge Component - Style definitions
 */
import type { DramaCategory } from '@dramadetector/shared';
import { getDramaCategoryColor } from '../lib/utils';
import { getCategoryLabel, getCategoryEmoji } from '@dramadetector/shared';

export interface DramaBadgeConfig {
  category: DramaCategory;
  showEmoji?: boolean;
}

export const dramaBadgeStyles = {
  container: 'inline-flex flex-row items-center justify-center rounded-full px-3 py-1.5 gap-1',
  emoji: 'text-sm',
  label: 'text-sm font-semibold',
};

export function getDramaBadgeContent(category: DramaCategory, showEmoji: boolean = true) {
  return {
    label: getCategoryLabel(category),
    emoji: showEmoji ? getCategoryEmoji(category) : null,
    className: getDramaCategoryColor(category),
  };
}
